/* global $ */
import React, { useState } from "react";

const StudentPresidentRequirement = () => {
    document.title = "Student President Requirements - CGES.CLUB";
    return (
        <>
            <CGESStudentPresidentForm />
        </>
    )
};

export default StudentPresidentRequirement;


function CGESStudentPresidentForm() {
    const [validated, setValidated] = useState(false);
    const [eventExperience, setEventExperience] = useState(null);
    const [submitted, setSubmitted] = useState(false);

    const scrollToFirstError = (form) => {
        const firstInvalid = form.querySelector(
            "input:invalid, textarea:invalid, select:invalid"
        );

        if (firstInvalid) {
            firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" });
            firstInvalid.focus();
        }
    };

const handleSubmit = async (e) => {
  const form = e.currentTarget;

  if (!form.checkValidity()) {
    e.preventDefault();
    e.stopPropagation();
    scrollToFirstError(form);
  } else {
    e.preventDefault();

    // ---- Helper to collect checkbox groups ----
    const getCheckboxValues = (name) =>
      Array.from(form.querySelectorAll(`input[name="${name}"]:checked`))
        .map(el => el.value)
        .join(", ") || "";

    // -------- ORDERED OBJECT (SAME AS FORM ORDER) --------
    let data = {
      // ===== 1. Institution Details =====
      "Institution Name": form["Institution Name"].value,
      "Type of Institution": form["Type of Institution"].value,
      "Type of Institution (Others)":
        form["Type of Institution (Others)"].value || "",
      "City": form["City"].value,
      "State": form["State"].value,

      // ===== 2. Student President Details =====
      "Full Name": form["Full Name"].value,
      "Course / Department": form["Course or Department"].value,
      "Year of Study": form["Year of Study"].value,
      "Student Email": form["Student Email"].value,
      "Student Phone": form["Student Phone"].value,
      "LinkedIn / Instagram":
        form["LinkedIn or Instagram"].value || "",

      // ===== 3. Leadership & Responsibilities =====
      "Current Role": form["Current Role"].value,
      "Current Role (Others)":
        form["Current Role (Others)"].value || "",
      "Students Represented": form["Students Represented"].value,

      // ===== 4. Interest in CGES.CLUB Programs =====
      "Program Interests": getCheckboxValues("Program Interests"),

      // ===== 5. Student Community Interests =====
      "Community Interests": getCheckboxValues("Community Interests"),

      // ===== 6. Event Coordination Experience =====
      "Event Experience": form["Event Experience"].value,
    };

    if (eventExperience) {
      data = {
        ...data,
        "Event Experience Details":
          form["Event Experience Details"].value || "",
      };
    }

    // ===== 7. Availability & Commitment =====
    data = {
      ...data,
      "Weekly Time": form["Weekly Time"].value,
      "Willing to Coordinate":
        form["Willing to Coordinate"].value,
    };

    // ===== 8. Why CGES Student President =====
    data = {
      ...data,
      "Why CGES Student President":
        form["Why CGES Student President"].value,
    };

    try {
      const response = await fetch(
        "https://n8n.chennaigames.com/webhook/student-president-application",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );
     
      if (response.ok) {

        setSubmitted(true);
      } else {
        alert("Failed to send details. Please try again.");
      }
    } catch (error) {
      console.error("Error sending form:", error);
      alert("Network error. Please try again.");
    }
  }

  setValidated(true);
};


    return (
        <>
            <style>
                {`
        .form-head-block {
          padding-bottom: 16px;
          margin-bottom: 18px;
          border-bottom: 1px solid #2f2f2f;
        }

        .form-head-block h1 {
          font-size: clamp(1.2rem, 2.8vw, 1.9rem);
          font-weight: 700;
          margin: 0 0 10px;
          color: #ffffff;
        }

        .form-head-block p {
          margin: 0;
          color: #d6d6d6;
          line-height: 1.7;
          font-size: clamp(0.9rem, 1.8vw, 1.02rem);
        }

        .dark-card {
          background-color: #161616;
          color: #e4e4e4;
          border: 1px solid #2a2a2a;
          border-radius: 16px;
        }

        .dark-card h4, .dark-card h5 {
          color: #ff810e;
        }

        .dark-input {
          background-color: #000 !important;
          color: #e4e4e4 !important;
          border: 1px solid #333333;
        }

        .dark-card form label:not(.form-check-label) {
          display: inline-block;
          margin-bottom: 0.45rem;
          line-height: 1.4;
          font-weight: 500;
        }

        .form-check-input {
          background-color: #0b0f14;
          border: 1px solid #ff810e;
        }

        .form-check-input:checked {
          background-color: #ff810e;
          border-color: #ff810e;
        }

        .btn-orange {
          background-color: #ff810e;
          border: none;
          color: white;
          font-weight: 600;
        }

        .dark-shadow {
          box-shadow: 0 16px 32px rgba(0, 0, 0, 0.35);
        }

        .thank-you-box {
          background: #161616;
          color: #e4e4e4;
          padding: 40px;
          border-radius: 10px;
          text-align: center;
        }

        /* ===== REMOVE ALL GREEN VALID HIGHLIGHTS ===== */

/* Inputs, textareas, selects */
.was-validated .form-control:valid,
.form-control.is-valid {
  border-color: #333333 !important;
  background-image: none !important;
  box-shadow: none !important;
}

/* Radio & Checkbox inputs */
.was-validated .form-check-input:valid,
.form-check-input.is-valid {
  border-color: #ff810e !important;
  background-image: none !important;
  box-shadow: none !important;
}

/* VERY IMPORTANT: Remove green color from labels of valid radios/checkboxes */
.was-validated .form-check-input:valid ~ .form-check-label,
.form-check-input.is-valid ~ .form-check-label {
  color: #e4e4e4 !important;
}

/* Also prevent Bootstrap from changing label color in any case */
.form-check-label {
  color: #e4e4e4 !important;
}

        .form-check {
          margin-bottom: 0.55rem;
          padding-left: 1.65rem;
        }

        .form-check-input {
          margin-top: 0.2rem;
        }

        .form-control {
          min-height: 44px;
        }

        .section-title {
          border-bottom: 1px solid #2f2f2f;
          padding-bottom: 8px;
          margin-top: 2rem !important;
          margin-bottom: 1rem;
        }

        .dark-card form .mb-3,
        .dark-card form .row {
          margin-bottom: 1rem !important;
        }

        .dark-card form .row {
          row-gap: 0.5rem;
        }

        .dark-card form button.btn {
          min-height: 44px;
          padding: 10px 24px;
          margin-top: 1.6rem !important;
        }

        .form-shell {
          max-width: 980px;
        }

        @media (max-width: 768px) {
          .form-head-block {
            margin-bottom: 14px;
            padding-bottom: 12px;
          }

          .dark-card {
            padding: 18px !important;
          }

          .container.mt-5.mb-5 {
            margin-top: 1.25rem !important;
            margin-bottom: 1.5rem !important;
          }

          .section-title {
            margin-top: 1.5rem !important;
          }
        }
        `}
            </style>

            <div className="container mt-5 mb-5 form-shell" style={{ marginTop: "100px" }}>
                <div className="card dark-card dark-shadow p-4">
                    <div className="form-head-block">
                        <h1>CGES Student President Application Form</h1>
                        <p>
                            Be the bridge between your campus and CGES.CLUB. Apply to lead esports events,
                            promote internships and scholarships, and build a vibrant gaming and tech
                            community in your institution.
                        </p>
                    </div>

                    {!submitted ? (
                        <>
                            <form
                                noValidate
                                className={validated ? "was-validated" : ""}
                                onSubmit={handleSubmit}
                            >

                                {/* ===== 1. Institution Details ===== */}
                                <h5 className="mt-4 section-title">1. Institution Details</h5>

                                <div className="mb-3">
                                    <label>Institution Name *</label>
                                    <input
                                        type="text"
                                        name="Institution Name"
                                        className="form-control dark-input"
                                        required
                                        placeholder="Ex: Anna University (Max 150 Characters)"
                                        maxLength={150}
                                    />
                                </div>

                                <label>Type of Institution *</label><br />
                                {["College", "University", "Academy / Training Centre", "Others"].map(v => (
                                    <div key={v} className="form-check text-light">
                                        <input
                                            type="radio"
                                            name="Type of Institution"
                                            value={v}
                                            required
                                            className="form-check-input"
                                            id={v}
                                        />
                                        <label className="form-check-label ms-2" htmlFor={v}>{v}</label>
                                    </div>
                                ))}

                                <input
                                    type="text"
                                    name="Type of Institution (Others)"
                                    className="form-control dark-input mt-2"
                                    placeholder="If others, specify (Max 150 Characters)"
                                    maxLength={150}
                                />

                                <div className="row mt-3">
                                    <div className="col-md-6">
                                        <label>City *</label>
                                        <input type="text" name="City" className="form-control dark-input" required maxLength={100} placeholder="Ex: Chennai (Max 100 Characters)" />
                                    </div>
                                    <div className="col-md-6">
                                        <label>State *</label>
                                        <input type="text" name="State" className="form-control dark-input" required placeholder="Ex: Tamil Nadu" maxLength={100} />
                                    </div>
                                </div>

                                {/* ===== 2. Student President Details ===== */}
                                <h5 className="mt-4 section-title">2. Student President Details</h5>

                                <div className="mb-3">
                                    <label>Full Name *</label>
                                    <input type="text" name="Full Name" className="form-control dark-input" required maxLength={150} placeholder="Ex: John Smith (Max 150 Characters)" />
                                </div>

                                <div className="mb-3">
                                    <label>Course / Dept *</label>
                                    <input type="text" name="Course or Department" className="form-control dark-input" required maxLength={150} placeholder="Ex: Computer Science (Max 150 Characters)" />
                                </div>

                                <label>Year of Study *</label>
                                {["1st Year", "2nd Year", "3rd Year", "Final Year"].map(v => (
                                    <div key={v} className="form-check text-light">
                                        <input
                                            type="radio"
                                            name="Year of Study"
                                            value={v}
                                            required
                                            className="form-check-input"
                                            id={v}
                                        />
                                        <label className="form-check-label ms-2" htmlFor={v}>{v}</label>
                                    </div>
                                ))}

                                <div className="mb-3 mt-3">
                                    <label>Email *</label>
                                    <input type="email" name="Student Email" className="form-control dark-input" required maxLength={150} placeholder="Ex: john@university.edu (Max 150 Characters)" />
                                </div>

                                <div className="mb-3">
                                    <label>Phone / WhatsApp *</label>
                                    <input
                                        type="tel"
                                        name="Student Phone"
                                        className="form-control dark-input"
                                        pattern="[0-9]{10}"
                                        required
                                        placeholder="10 digit phone number"
                                    />
                                </div>

                                <div className="mb-3">
                                    <label>LinkedIn / Instagram (Optional)</label>
                                    <input type="text" name="LinkedIn or Instagram" className="form-control dark-input" maxLength={150} placeholder="Ex: linkedin.com/in/john-smith (Max 150 Characters)" />
                                </div>

                                {/* ===== 3. Leadership & Responsibilities ===== */}
                                <h5 className="mt-4 section-title">3. Leadership & Responsibilities</h5>

                                <label>Current Role in College *</label>
                                {[
                                    "Student President",
                                    "Vice President",
                                    "Club Leader",
                                    "Class Representative",
                                    "Event Coordinator",
                                    "Others"
                                ].map(v => (
                                    <div key={v} className="form-check text-light">
                                        <input
                                            type="radio"
                                            name="Current Role"
                                            value={v}
                                            required
                                            className="form-check-input"
                                            id={v}
                                        />
                                        <label className="form-check-label ms-2" htmlFor={v}>{v}</label>
                                    </div>
                                ))}

                                <input
                                    type="text"
                                    name="Current Role (Others)"
                                    className="form-control dark-input mt-2"
                                    placeholder="If others, specify (Max 150 Characters)"
                                    maxLength={150}
                                />

                                <label className="mt-3">Number of students you represent *</label>
                                {["< 50", "50–100", "100+"].map(v => (
                                    <div key={v} className="form-check text-light">
                                        <input
                                            type="radio"
                                            name="Students Represented"
                                            value={v}
                                            required
                                            className="form-check-input"
                                            id={v}
                                        />
                                        <label className="form-check-label ms-2" htmlFor={v}>{v}</label>
                                    </div>
                                ))}

                                {/* ===== 4. Interest in CGES.CLUB Programs ===== */}
                                <h5 className="mt-4 section-title">4. Interest in CGES.CLUB Programs</h5>

                                {[
                                    "Organize Campus Esports Tournaments",
                                    "Promote CGES.CLUB Internships to Students",
                                    "Promote Scholarships to Eligible Students",
                                    "Coordinate Gaming / Tech Workshops",
                                    "Help in Campus Gaming Events",
                                    "Act as CGES Student Ambassador",
                                    "Work with Placement Cell for Student Opportunities",
                                    "Create Awareness about Gaming Careers"
                                ].map(v => (
                                    <div key={v} className="form-check text-light">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            name="Program Interests"
                                            value={v}
                                            id={v}
                                        />
                                        <label className="form-check-label ms-2" htmlFor={v}>{v}</label>
                                    </div>
                                ))}

                                {/* ===== 5. Student Community Interests ===== */}
                                <h5 className="mt-4 section-title">5. Student Community Interests</h5>

                                {["ESports", "Game Development", "Graphic Design", "Coding / Tech"].map(v => (
                                    <div key={v} className="form-check text-light">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            name="Community Interests"
                                            value={v}
                                            id={v}
                                        />
                                        <label className="form-check-label ms-2" htmlFor={v}>{v}</label>
                                    </div>
                                ))}

                                {/* ===== 6. Event Coordination Experience ===== */}
                                <h5 className="mt-4 section-title">6. Event Coordination Experience</h5>

                                <label>Have you organized any events before? *</label><br />
                                <label className="me-3 text-light">
                                    <input
                                        type="radio"
                                        name="Event Experience"
                                        value="Yes"
                                        onChange={() => setEventExperience(true)}
                                        required
                                        className="form-check-input me-1"
                                        
                                    /> Yes
                                </label>
                                <label className="text-light">
                                    <input
                                        type="radio"
                                        name="Event Experience"
                                        value="No"
                                        onChange={() => setEventExperience(false)}
                                        required
                                        className="form-check-input me-1"
                                    /> No
                                </label>

                                {eventExperience && (
                                    <textarea
                                        name="Event Experience Details"
                                        className="form-control dark-input mt-3"
                                        rows="3"
                                        placeholder="Mention briefly (Max 500 Characters)"
                                        required
                                        maxLength={500}
                                    ></textarea>
                                )}

                                {/* ===== 7. Availability & Commitment ===== */}
                                <h5 className="mt-4 section-title">7. Availability & Commitment</h5>

                                <label>Time per week *</label>
                                {["1–2 hours", "3–5 hours", "5+ hours"].map(v => (
                                    <div key={v} className="form-check text-light">
                                        <input
                                            type="radio"
                                            name="Weekly Time"
                                            value={v}
                                            required
                                            className="form-check-input"
                                            id={v}
                                        />
                                        <label className="form-check-label ms-2" htmlFor={v}>{v}</label>
                                    </div>
                                ))}

                                <label className="mt-3">Willing to coordinate with CGES team? *</label><br />
                                <label className="me-3 text-light">
                                    <input type="radio" name="Willing to Coordinate" value="Yes" required className="form-check-input me-1" /> Yes
                                </label>
                                <label className="text-light">
                                    <input type="radio" name="Willing to Coordinate" value="No" required className="form-check-input me-1" /> No
                                </label>

                                {/* ===== 8. Why CGES Student President ===== */}
                                <h5 className="mt-4 section-title">8. Why do you want to be CGES Student President?</h5>
                                <textarea
                                    name="Why CGES Student President"
                                    className="form-control dark-input"
                                    rows="4"
                                    required
                                    placeholder="Share your motivation (Max 500 Characters)"
                                    maxLength={500}
                                ></textarea>

                                <button type="submit" className="btn btn-orange mt-4">
                                    Submit
                                </button>
                            </form>
                        </>
                    ) : (
                        <div className="thank-you-box">
                            <h3>Thank You for Applying! 🙌</h3>
                            <p>Our team will review your application and contact you soon.</p>
                        </div>
                    )}

                </div>
            </div>
        </>
    );
}


